// extracted by mini-css-extract-plugin
export default {"button":"ngVvrUeRoZdeUcLhITIr","content":"AGcIzxKmZeGxDfWiLS07","pulse":"XRd1ouIxxVBVdUfmfkSX"};